import { LOCALES } from 'i18n/locales';

export const selectFeatureAttributeTableIntl = {
    [LOCALES.ENGLISH]: {
        'selectFeatureAttributeTable.column.property': 'Detail',
        'selectFeatureAttributeTable.column.value': 'Description'
    },
    [LOCALES.WELSH]: {
        'selectFeatureAttributeTable.column.property': '[Detail]',
        'selectFeatureAttributeTable.column.value': '[Description]'
    }
};
